module.exports = __webpack_public_path__ + "img/剪切2.ea032db8.svg";